export default __webpack_public_path__ + "static/media/user_selected.5818d02d.webp";